import React from 'react';
import { Icon, Text } from 'mintel-react-ui';
import { mintelGreen400 } from 'mintel-tokens';

import styles from './SharedComponents.scss';
import useTranslation from '../translations';

export default (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.thankyou}>
      <Icon
        name="checkmark"
        size={20}
        color={mintelGreen400}
        className={styles.checkmark}
      />
      <Text.Body2>
        <b>{t('Thank you for registering with Mintel.')}</b>
      </Text.Body2>
    </div>
  );
};
